import { render, staticRenderFns } from "./DrawList.vue?vue&type=template&id=51f2649e"
import script from "./DrawList.vue?vue&type=script&lang=ts"
export * from "./DrawList.vue?vue&type=script&lang=ts"
import style0 from "./DrawList.vue?vue&type=style&index=0&id=51f2649e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports